/**
 * 표 컬럼 메타 — 생성본(handoff/page.generated.tsx COLUMNS)의 제목·키·필수 표시를 옮긴 사본이다. 생성본은 컬럼 배열을 내보내지 않아(뷰 내부 상수)
 * 배선이 쓰는 두 곳(엑셀 업로드 헤더 → 키 · 저장 전 필수값 검사)을 위해 따로 둔다. 재핸드오프로 컬럼이 바뀌면 이 표도 함께 고친다 —
 * columnMeta.test.ts 가 생성본 원문과 어긋나면 실패한다.
 */
export const COLUMN_META: { title: string; key: string; required: boolean }[] = [
  { title: '화주유형', key: 'service_type', required: false },
  { title: '화주명', key: 'shipper_name', required: false },
  { title: '화주코드', key: 'SPR_NM', required: true },
  { title: '입고번호', key: 'ORD_OPT_NO', required: false },
  { title: '배송유형', key: 'TRS_TYPE', required: false },
  { title: '거래유형', key: 'LOT_ATTR5', required: false },
  { title: 'SKUID', key: 'sku_id', required: false },
  { title: '불량구분', key: 'LOT_ATTR4', required: false },
  { title: '입고예정일자', key: 'PLN_DATE', required: true },
  { title: '바코드', key: 'BARCODE', required: true },
  { title: '상품명', key: 'GDS_NM', required: true },
  { title: '수량', key: 'ORD_QTY', required: true },
  { title: '옵션코드', key: 'option_code', required: false },
  { title: '입고센터', key: 'WH_NM', required: false },
  { title: '스타일넘버', key: 'STL_NO', required: false },
  { title: '옵션', key: 'GDS_OPT', required: false },
  { title: '품목', key: 'GDS_GROUP1', required: false },
  { title: '브랜드', key: 'BRD_NM', required: false },
  { title: '생성일자', key: 'INS_DATE', required: false },
  { title: '생성자', key: 'INS_BY', required: false },
  { title: '수정일자', key: 'UPD_DATE', required: false },
  { title: '수정자', key: 'UPD_BY', required: false },
  { title: '원주문번호', key: 'REF_NO1', required: false },
  { title: '원일련번호', key: 'REF_NO2', required: false },
  { title: '비고', key: 'PROC_NM', required: false },
  { title: 'UID', key: 'UID', required: false },
  { title: '송장', key: 'REF_NO3', required: false },
  { title: '수하인', key: 'TRS_NM', required: false },
  { title: '전화', key: 'TRS_NUMBER', required: false },
  { title: '휴대폰', key: 'TRS_PHONE', required: false },
  { title: '주소', key: 'TRS_ADDR', required: false },
  { title: '판매업체', key: 'SAL_CHANNEL', required: false },
  { title: '반송번호', key: 'TRS_INVOICE_NO', required: false },
  { title: '반품택배', key: 'TRS_LSP_NM', required: false },
  { title: '반품계좌', key: 'ETC1', required: false },
  { title: '반송금액', key: 'ETC2', required: false },
  { title: '착불금액', key: 'ETC3', required: false },
  { title: '선/착불', key: 'ETC4', required: false },
  { title: '정불구분', key: 'ETC5', required: false },
  { title: '담당자 확인', key: 'ETC6', required: false },
  { title: '첨부', key: 'ATCH_FILE', required: false },
  { title: '동영상', key: 'VIDEO', required: false },
  { title: '반품일련번호', key: 'claim_id', required: false },
  { title: '최종귀책', key: 'final_responsibility', required: false },
]
